import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { type BoxProps, Card, Text, Timeline, Title, Flex } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreInquiry } from '@flecto/types'
import { Icon } from '@flecto/ui'

import { useStoreDetails } from '../../hooks/useStoreDetails'

export type CardOrderConfirmationProps = BoxProps & {
  order?: CoreInquiry
}

export function CardOrderConfirmation({
  order,
  ...props
}: CardOrderConfirmationProps) {
  const { t } = useTranslation('store', {
    keyPrefix: 'store-page-confirmation',
  })
  const store = useStoreDetails()

  if (!order) {
    return
  }

  return (
    <Card {...props}>
      <Title order={5}>
        <Flex align='center' gap='xs'>
          {t('card_order_confirmation.title')}{' '}
          <Icon icon={faCheck} color='green.6' />
        </Flex>
      </Title>
      <Text>{t('card_order_confirmation.subtitle')}</Text>
      <Timeline active={1} bulletSize={24} lineWidth={2} mt='xl' color='green'>
        <Timeline.Item
          bullet={1}
          title={t('card_order_confirmation.label_timeline_title_1')}
        >
          <Text c='dimmed' size='sm'>
            {t('card_order_confirmation.label_timeline_description_1', {
              store: store?.name,
            })}
          </Text>
        </Timeline.Item>

        <Timeline.Item
          bullet={2}
          title={t('card_order_confirmation.label_timeline_title_2')}
          lineVariant='dashed'
        >
          <Text c='dimmed' size='sm'>
            {t('card_order_confirmation.label_timeline_description_2', {
              store: store?.name,
            })}
          </Text>
        </Timeline.Item>

        <Timeline.Item
          title={t('card_order_confirmation.label_timeline_title_3')}
          bullet={3}
        >
          <Text c='dimmed' size='sm'>
            {t('card_order_confirmation.label_timeline_description_3')}
          </Text>
        </Timeline.Item>
      </Timeline>
    </Card>
  )
}
